import corner from '@assets/svg/playersTab/cards_corner_light.svg';
import redCard from '@assets/svg/playersTab/cards_red_light.svg';
import yellowCard from '@assets/svg/playersTab/cards_yellow_light.svg';
import yellowCardDark from '@assets/svg/playersTab/cards_yellow_dark.svg';
import redCardDark from '@assets/svg/playersTab/cards_red_dark.svg';
import cornerDark from '@assets/svg/playersTab/cards_corner_dark.svg';
import { useTheme } from '@stores/useTheme';
import SmallSpinner from '@components/common/SmallSpinner';
import { T } from "@utils/enums";
import SmallSpinnerTimeout from '@components/common/SmallSpinnerTimeout';
interface OneCardProps {
    type: 'corner' | 'red' | 'yellow';
    count: number;
    width?: number;
    height?: number;
}

const OneCard: React.FC<OneCardProps> = ({ type, count, width="12", height="16" }) => {
    const { theme } = useTheme();
    const renderImage = () => {
        if (type === 'corner' && theme === T.DARK) return cornerDark;
        if (type === 'red' && theme === T.DARK) return redCardDark;
        if (type === 'yellow' && theme === T.DARK) return yellowCardDark;
        if (type === 'corner') return corner;
        if (type === 'red') return redCard;
        if (type === 'yellow') return yellowCard;
    }
    
    return (
        <div data-testid={`${type}-card`} className="w-auto min-w-[12px] h-full flex flex-col justify-center items-center">
            <img className={`w-[${width}px] h-[${height}px]`} src={renderImage()} alt={type} />
            {count !== null ? <span className="text-[16px] leading-[24px] font-robotoMedium font-medium text-base120 dark:text-monoY">{count}</span> : 
            <span className="h-[24px] flex items-center justify-center">
                <SmallSpinnerTimeout />
            </span>}
        </div>
    )
}

interface CardsRowProps {
    homeCorners: number;
    homeYellowCards: number;
    homeRedCards: number;
    awayCorners: number;
    awayYellowCards: number;
    awayRedCards: number;
}

const CardsRow: React.FC<CardsRowProps> = ({ homeCorners, homeYellowCards, homeRedCards, awayCorners, awayYellowCards, awayRedCards }) => {
    const { theme } = useTheme();
    return (
        <div data-testid="sc_stats_cards_home" className="w-full h-[40px] flex mt-[17px]">
            <div className="flex w-[50%] gap-[17px] pl-[16px]">
                <OneCard type="corner" count={homeCorners} />
                <OneCard type="yellow" count={homeYellowCards} />
                <OneCard type="red" count={homeRedCards} />
            </div>
            <div data-testid="sc_stats_cards_away" className="flex w-[50%] justify-end gap-[17px] pr-[16px]">
                <OneCard type="corner" count={awayCorners} />
                <OneCard type="yellow" count={awayYellowCards} />
                <OneCard type="red" count={awayRedCards} />
            </div>
        </div>
    )
}

export default CardsRow;
